module.exports = __webpack_public_path__ + "img/金属材料学7_9.fdb22c9b.png";